import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileDownloadType } from 'src/app/core/services/file-download/file-download.service';
import { FileSaverService } from 'src/app/core/services/file-saver-service/file-saver.service';
import {
  MixpanelEventType,
  MixpanelService,
} from 'src/app/core/services/mixpanel-service/mixpanel.service';

export interface ILegalFileService {
  downloadCustomerTermsOfService: () => void;
  downloadTerminalTermsOfService: () => void;
  downloadProducerAgreement: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class LegalFileService implements ILegalFileService {
  constructor(
    private http: HttpClient,
    private fileSaverService: FileSaverService,
    private mixpanelService: MixpanelService,
  ) {}

  download(pdfSource: string) {
    switch (pdfSource) {
      case FileDownloadType.CUSTOMER_TERMS_OF_SERVICE:
        this.mixpanelService.track(
          MixpanelEventType.SIGNUP_PAYMENT_CUSTOMER_TERMS_OF_SERVICE_DOWNLOADED,
        );
        this.downloadCustomerTermsOfService();
        break;
      case FileDownloadType.TERMINAL_TERMS_OF_SERVICE:
        this.mixpanelService.track(
          MixpanelEventType.SIGNUP_PAYMENT_TERMINAL_TERMS_OF_SERVICE_DOWNLOADED,
        );
        this.downloadTerminalTermsOfService();
        break;
      case FileDownloadType.PRODUCER_AGREEMENT:
        this.mixpanelService.track(
          MixpanelEventType.SIGNUP_PAYMENT_PRODUCER_AGREEMENT_DOWNLOADED,
        );
        this.downloadProducerAgreement();
        break;
    }
  }

  downloadCustomerTermsOfService() {
    return this.http
      .get(FileDownloadType.CUSTOMER_TERMS_OF_SERVICE, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      })
      .subscribe((pdfBlob) =>
        this.fileSaverService.saveAs(
          pdfBlob,
          'BoldPenguinCustomerTermsOfService-2024Feb.pdf',
        ),
      );
  }

  downloadTerminalTermsOfService() {
    return this.http
      .get(FileDownloadType.TERMINAL_TERMS_OF_SERVICE, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      })
      .subscribe((pdfBlob) =>
        this.fileSaverService.saveAs(
          pdfBlob,
          'BoldPenguinTerminalTermsOfService-2022Nov.pdf',
        ),
      );
  }

  downloadProducerAgreement() {
    return this.http
      .get(FileDownloadType.PRODUCER_AGREEMENT, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      })
      .subscribe((pdfBlob) =>
        this.fileSaverService.saveAs(
          pdfBlob,
          'BoldPenguinProducerAgreement-2024May.pdf',
        ),
      );
  }
}
